export function getCategory(
  birthYear: number,
  competitionYear = 2027
): string {

  const age = competitionYear - birthYear;

  if (age < 9) return "U9";
  if (age < 11) return "U11";
  if (age < 13) return "U13";
  if (age < 15) return "U15";
  if (age < 18) return "U18";
  return "U21+";
}

const PAID_CATEGORIES = ["U15", "U18"];
const REGISTRATION_FEE = 10;

export function getAmountDue(category: string): number {
  return PAID_CATEGORIES.includes(category)
    ? REGISTRATION_FEE
    : 0;
}
